var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main_center lawEnforcement_detail" }, [
    _c("div", { staticClass: "top-content busWinessLeft" }, [
      _c(
        "div",
        { staticClass: "left-navbar" },
        [_c("el-button", { on: { click: _vm.backRouter } }, [_vm._v("返回")])],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "right-content busWinessRight" },
      [
        _c(
          "el-card",
          { staticClass: "box-card" },
          [
            _c(
              "div",
              {
                staticClass: "clearfix",
                attrs: { slot: "header" },
                slot: "header",
              },
              [_c("span", [_vm._v("举报信息")])]
            ),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: { model: _vm.form, "label-width": "200px" },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "项目名称：", prop: "projectName" },
                          },
                          [_vm._v(" " + _vm._s(_vm.form.projectName) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "举报方式：", prop: "reportWay" } },
                          [_vm._v(" " + _vm._s(_vm.form.reportWayName) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "举报时间：", prop: "reportTime" },
                          },
                          [_vm._v(" " + _vm._s(_vm.form.reportTime) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "举报人：", prop: "userName" } },
                          [_vm._v(" " + _vm._s(_vm.form.userName) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "身份证号：", prop: "idNo" } },
                          [_vm._v(" " + _vm._s(_vm.form.idNo) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "居住地址：", prop: "userAddress" },
                          },
                          [_vm._v(" " + _vm._s(_vm.form.userAddress) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "手机号：", prop: "userPhone" } },
                          [_vm._v(" " + _vm._s(_vm.form.userPhone) + " ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num / 2 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "Email：", prop: "userEmail" } },
                          [_vm._v(" " + _vm._s(_vm.form.userEmail) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: _vm.num } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "举报内容：", prop: "contentText" },
                          },
                          [_vm._v(" " + _vm._s(_vm.form.contentText) + " ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  _vm._l(_vm.form.attachments, function (item, index) {
                    return _c(
                      "el-col",
                      { key: index, attrs: { span: _vm.num } },
                      [
                        _c("affix-doc", {
                          staticClass: "affixDown",
                          attrs: {
                            type: "complaint_reporting_att",
                            labelWidth: "200px",
                            name: item.fileTypeName,
                            item: item,
                          },
                          on: {
                            "update:item": function ($event) {
                              item = $event
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }